import { apiService } from '../../../shared/services/apiServices';
import technicianEndpoints from './technicianEndpoints';
import {
  UpdateTechnicianRequest,
  UpdateTechnicianResponse,
  MediaResource,
} from '../types/editTechnicianType';
interface EditTechnicianResult {
  success: boolean;
  forbidden?: boolean;
  data?: UpdateTechnicianResponse;
}

export const editTechnicianApiService = async (
  id: string,
  payload: UpdateTechnicianRequest,
  profile?: MediaResource,
  docs?: MediaResource[]
): Promise<EditTechnicianResult> => {
  const url = `${technicianEndpoints.TECHNICIANS}/${id}`;

  try {
    const requestBody: UpdateTechnicianRequest = { ...payload };

    if (profile) {
      requestBody.profile = profile;
    }

    if (docs && docs.length > 0) {
      requestBody.docs = docs;
    }

    const result = await apiService.patchAPI(url, requestBody, {
      skipGlobalErrorRedirect: true,
    });

    if (result.error && result.status === 403) {
      return { success: false, forbidden: true };
    }

    if (result.error) {
      return { success: false };
    }

    return { success: true, data: result.data as UpdateTechnicianResponse };
  } catch (_error) {
    return { success: false };
  }
};
